import { render, staticRenderFns } from "./CoursewareContentShared.vue?vue&type=template&id=b96c23a6&"
import script from "./CoursewareContentShared.vue?vue&type=script&lang=js&"
export * from "./CoursewareContentShared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports